import React, { Component } from 'react';
import { Grid, } from 'semantic-ui-react'
import ImageSearchCustomHit from './ImageSearchCustomHit'
import { firebaseAuth, logComponentLoad,} from '../../../config/constants';
import { checkAdminEmail } from '../../dashBoard/newDashboard/algoliaDashboard/AlgoliaMiscUtils';

import {
    InstantSearch,
    Hits,
    SearchBox,
    Highlight,
    RefinementList,
    Pagination,
    CurrentRefinements,
    ClearRefinements,
    Configure
} from 'react-instantsearch/dom';
import { connectHits } from "react-instantsearch/connectors";
import ImageView from '../ImageFinder/ImageView'

function Product({ hit }) {

    //  let tempHit = hit;
    hit.key = hit.objectID;

    let user = {
        email: 'ivanmworozi@gmail.com'
    }

    const orderSection = user
        ?
        <ImageView
            //user={this.state.userFromFirebaseNode}
            user={user}
            imageObject={hit} />
        : ''

    return <div style={{ marginTop: '10px' }}>
        {/* <span className="hit-name">
            <div>{hit.order_num}</div>
            <Highlight attribute="name" hit={hit} />
            <br />
            <Highlight attribute="phone" hit={hit} />
        </span>
        <br />
        {image} */}
        {orderSection}

    </div>
}


function Search(user) {
    return (
        <div >
            <Pagination />
            <CurrentRefinements />
            <ClearRefinements />
            <SearchBox />
            <RefinementList attribute="shirtType" />
            <br />
            <RefinementList attribute="shirtColor" />
            <br />
            <RefinementList attribute="printType" />

            {/* <Hits hitComponent={Product} /> */}

        </div>
    );
}


const ConnectedCustomHits = connectHits(ImageSearchCustomHit);

class ImageSearch extends Component {
    constructor(props) {
        super(props);
        this.state = {
            algoliaUser:''
        }
    }

    componentDidMount() {

        firebaseAuth().onAuthStateChanged((user) => {

            if (user) {
              //  console.log("soarch1 user is signed in:" + user.email);

                if (user.email) {
                   // console.log("soarch01 user.email  is:" + user.email);
                    this.setState({
                        user: user
                    })

                    checkAdminEmail(user.email, this.setAdminResult);

                    this.setState({
                        user: user,
                        loadingUser: false,
                    })
    
                    // this.loadOrders(this.props.match.params.order_num);

                }

            } else {
                console.log("user is NOT signed in:" + user.uid);
            }

            this.setState({
                loadingUser: false
            })
        });


    }

    setAdminResult = (returnObject) => {
       // console.log("++++++ soarch13 setAdminResult");
       // console.log("soarch14 returnObject:" + JSON.stringify(returnObject, null, 3));

        logComponentLoad(returnObject, "ImageSearch");

        this.setState({
            algoliaUser: returnObject.algoliaUser,
            //isAdmin: returnObject.isAdmin,
            loadingUser:false
        })

        if(returnObject.isAdmin){

            
        }
    }

    render() {

        const wholeUI = this.state.algoliaUser && this.state.algoliaUser != '' && this.state.algoliaUser.isAdmin 
            ? <div>
                 <InstantSearch
                    appId="FV5Z3H1RLH"
                    apiKey="d0f85b740985c2c15bf624a6f4ef7dd2"
                    indexName="imageFinder"
                >
                {/* <Configure hitsPerPage={5}/> */}
                    {/* Search widgets will go there */}
                    
                    <Search />
                    <ConnectedCustomHits/>
                </InstantSearch>
            </div>
            : <h4>loading error a75</h4>

        return (
            <div>

                {wholeUI}

               
            </div>)
    }
}

export default ImageSearch;



// WEBPACK FOOTER //
// ./src/components/newSite/ImageFinder/ImageSearch.js